module.exports = __webpack_public_path__ + "e115a152c43a5c1d82d8ad2f12cb238c.svg";